<template>
  <v-flex>
    <order-draft-item-note
      :product="product"
      @note-added="$emit('note-added', $event)"/>

    <div class="mt-2">
      <template v-for="(note, index) in notes">
        <v-combobox
          :key="index"
          v-model="note.values"
          :label="$t(note.name)"
          readonly
          chips
          multiple
          append-icon=""
        >
          <v-icon
            slot="prepend"
            medium
            class="mt-1"
            @click="removeNote(note.name)"
          >
            close
          </v-icon>
        </v-combobox>
      </template>
    </div>
  </v-flex>
</template>

<script>
import OrderDraftItemNote from './OrderDraftItemNote'

export default {
  name: 'OrderDraftItemNotes',

  components: {
    OrderDraftItemNote
  },

  props: {
    product: {
      type: Object,
      default: null
    },
    order: {
      type: Object,
      required: true
    },
    noAddButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    notes () {
      if (!this.product) {
        return []
      }

      if (!this.order.hasNotes(this.product)) {
        return []
      }

      if (Array.isArray(this.product.notes)) {
        return [
          {
            name: 'Notes',
            values: this.product.notes
          }
        ]
      }

      return Object.entries(this.product.notes).map(([key, value]) => {
        return {
          name: key,
          values: value
        }
      })
    }
  },

  methods: {
    removeNote (byName) {
      if (byName === 'Notes') {
        this.product.notes = []
        return
      }

      let notes = { ...this.product.notes }
      delete notes[byName]
      this.product.notes = notes
      if (!this.order.hasNotes(this.product)) {
        this.product.notes = []
      }
    }
  }
}
</script>
